import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changeValidStatus } from ".";
import { useChangeValidStatusProps } from ".";
import { queryKeys } from "@/lib/useQuery/queryKeys";

export function useChangeValidStatus() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["field_types"],
        mutationFn: async (props: useChangeValidStatusProps) => {
            const res = await changeValidStatus(props);
            if (res.error) throw new Error(res.error.message);
            return res;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question._def, exact: false });
            queryClient.invalidateQueries({ queryKey: queryKeys.response._def, exact: false });
        },
    });
} 
